import PropTypes from 'prop-types'

import Flyout from './PasswordFlyout'
import PasswordInput from './PasswordInput'
import Input from './Input'
import MaskTextButton from './MaskTextButton'
import criteria from '../password_criteria.json'
import {If} from '../deprecated/IfFlag'
import CompoundFormComponent from './CompoundFormComponent'
import Wrapper from './Wrapper'

import './password.scss'

export default class Password extends CompoundFormComponent {
  constructor(props) {
    super(props)
    this.state = {
      showFlyout: false,
      showPassword: false
    }

    this.onPassBlur = this.onPassBlur.bind(this)
    this.onPassFocus = this.onPassFocus.bind(this)
    this.toggleMask = this.toggleMask.bind(this)
  }

  onPassBlur() {
    this.setState({showFlyout: false})
  }

  onPassFocus() {
    this.setState({showFlyout: true})
  }

  toggleMask(event) {
    event.preventDefault()

    this.setState({showPassword: !this.state.showPassword})
  }

  render() {
    return (
      <div className='password'>
        <div className='input-and-mask-toggle-container'>
          <Wrapper label={this.props.label} name={this.props.name} errors={this.errors()}>
            <Input
              autoComplete='new-password'
              className='password'
              maxLength={128}
              name='password'
              type={this.state.showPassword ? 'text' : 'password'}
              onBlur={this.onPassBlur}
              onFocus={this.onPassFocus}
              placeholder={this.props.placeholder}
              label={null}
              wrap={false}
            />
            <MaskTextButton
              className='mask-icon-and-text'
              showText={this.state.showPassword}
              toggleButton={this.toggleMask}
            />
          </Wrapper>
        </div>
        <If flag={this.state.showFlyout && this.props.showFlyout}>
          <Flyout
            header='Password must be a minimum of 12 characters. Longer passwords are more secure.'
            subtitle='Consider using a memorable phrase or use a password manager to generate one.'
          />
        </If>
        {this.props.showConfirmation &&
          <PasswordInput
            autoComplete='new-password'
            className='password-confirmation'
            label='Confirm password'
            name='password_confirmation'
            placeholder={this.props.placeholder ? `Confirm ${this.props.placeholder.toLowerCase()}` : null}
            type='password'
          />
        }
      </div>
    )
  }
}

Password.propTypes = {showFlyout: PropTypes.bool}
Password.defaultProps = {
  showConfirmation: true,
  showFlyout: true,
  validator: (name, data) => {
    var password = data.password ? data.password : ''
    if (password.length === 0)
      return {name: 'password', errors: ["Password can't be empty."]}

    if (password.length > 128)
      return {name: 'password', errors: ['Password is too long. Maximum length is 128 characters.']}

    if ((/^\s*$/).test(password))
      return {name: 'password', errors: ['Password cannot contain only spaces.']}

    if (password !== data.password_confirmation)
      return {name: 'password_confirmation', errors: ["Passwords don't match. Please try again."]}

    var isValid = true
    criteria.forEach(criterion => {
      isValid = isValid && criterion.regex.test(password)
    })

    if (!isValid)
      return {name: 'password', errors: ['Password must be a minimum of 12 characters.']}

    if (data.email && password.toLowerCase() === data.email.toLowerCase().trim())
      return {name: 'password', errors: ['Password cannot be the same as your email address.']}
  }
}
